import * as Yup from "yup";
import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useHistory, useLocation } from "react-router-dom";
import { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import DropDownMenu from "./Menu";
import { FormControlLabel, MenuItem, RadioGroup, Select } from "@mui/material";
import Menu from "@mui/material/Menu";
import { Drawer } from "rsuite";
import { MoreVertSharp } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Radio from "@mui/material/Radio";
import { useEffect } from "react";
// import noListData from "../Images/nolist.svg";
import noListData from "../Images/ImageToStl.com_nolist.avif";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Loader from "../Loader";
import Contact from "../Contacts/Contact";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FormControl from "@mui/material/FormControl";
import { createContactFormSchema } from "../Schemas/ChangePassword";
import {
  useFormik,
  Form,
  Field,
  FieldArray,
  Formik,
  ErrorMessage,
  isValid,
  dirty,
} from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TextField } from "@mui/material";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min";
import { Helmet } from "react-helmet";
import ImportForList from "../Contacts/ImportForList";
import { SearchSvgIcon } from "../CommonSvgs";

export default function ListTable() {
  const history = useHistory();
  const [order, setOrder] = useState("asc");
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [moreAnchorEl, setmoreAnchorEl] = useState(null);
  const openMore = Boolean(moreAnchorEl);
  const [openModal, setOpenModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsCopy, setRowsCopy] = useState([]);
  const [listTitle, setListTitle] = useState("");
  const [nameListId, setNameListId] = useState("");
  const [listDataArr, setListDataArr] = useState([]);
  const [listDataArrCopy, setListDataArrCopy] = useState([]);
  const [typesArr, setTypesArr] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [openCreateContactForm, setOpenCreateContactForm] = useState(false);
  const location = useLocation();
  const [selectedList, setSelectedList] = useState("");
  const [listName, setListName] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [staus, setStaus] = useState(false);
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedListContacts, setSelectedListContacts] = useState("");
  const [selectedListContactsCopy, setSelectedListContactsCopy] = useState({});
  const [formFields, setFormFields] = useState({});
  const [formFieldArray, setFormFieldArray] = useState([]);
  const [duplicateFormArray, setDuplicateFormArray] = useState([]);
  const [openDrawerForCreateList, setOpenDrawerForCreateList] = useState(false);
  const [dynamicForm, setDynamicForm] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Phone: "",
    CompanyName: "",
    Website: "",
    DoNotImport: "",
  });
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [catchSearchValue, setCatchSearchValue] = useState("");

  const openMenuFilter = Boolean(menuAnchorEl);

  const handleClickMenuItem = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenuFilter = () => {
    setMenuAnchorEl(null);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleOpenModal = () => {
    history.push("/Contacts/Import-options");
    // setListTitle("");
    // setOpenModal(true);
  };
  useEffect(() => {
    getAllNameList();
  }, [location.pathname, staus]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  function createData(id, name, calories, fat, carbs, protein) {
    return {
      id,
      name,
      calories,
      fat,
      carbs,
      protein,
    };
  }

  const headCells = [
    {
      id: 1,
      label: "Lists",
    },
    {
      id: 3,
      label: "Contacts",
    },
    {
      id: 4,
      label: "Creation date",
    },
    {
      id: 5,
      label: "Actions",
    },
  ];
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  function EnhancedTableHead(props) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;

    return (
      <TableHead>
        <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={"left"}
              sx={{
                width: headCell.id === 1 ? "25%" : "20%",
                fontSize: "14px",
                color: "#000",
                fontWeight: 700,
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                padding: "10px",
              }}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  function getAllNameList() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/contact/get-all-name-list/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setRows(response.data.details);
          setRowsCopy(response.data.details);
          setListDataArr(response.data.details);
          setListDataArrCopy(response.data.details);
        } else {
          setListDataArr([]);
          setListDataArrCopy([]);
          setRows([]);
          setRowsCopy([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setShowLoader(false);
      })
      .catch((err) => console.log("Error"));
  }

  const [value, setValue] = useState(null);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    borderRadius: "6px",
    boxShadow: 24,
    p: 2,
  };

  const handleCreateList = (e) => {
    setListTitle(e.target.value);
  };

  function createNewNameList() {
    let nameListDatas = {
      name: listTitle,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/contact/create-name-list/${
          userDetails && userDetails.details._id
        }`,
        nameListDatas,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpenModal(false);
          getAllNameList();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = useMemo(
    () => rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, rows]
  );
const [deleteLoader,setDeleteLoader]=useState(false)
  function deleteListName() {
    setDeleteLoader(true)
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/contact/delete-name-list/${
          userDetails && userDetails.details._id
        }/${selectedListId._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setDeleteLoader(false)
          getAllNameList();
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setDeleteLoader(false)
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
      setOpen2(false);
  }

  function convertDatetoExactFormat(dateString) {
    const date = new Date(dateString);

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate = date.toLocaleString("en-US", options);

    return formattedDate;
  }

  const handleSearchRecords = (e) => {
    setCatchSearchValue(e.target.value);
  };

  useEffect(() => {
    // console.log("records---------------",rowsCopy.filter((row)=> row.Name.toLowerCase().includes(catchSearchValue.toLowerCase())));
    const filteredRecords = rowsCopy.filter((row) =>
      row.Name.toLowerCase().includes(catchSearchValue.toLowerCase())
    );
    if (filteredRecords.length > 0) {
      setRows(filteredRecords);
    } else {
      setRows([]);
    }
  }, [catchSearchValue]);

  const listComponentUi = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              borderBottom: "1px solid #DDD",
              padding: "6px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              disableRipple
              disableElevation
              sx={{
                cursor: "default",
                outline: "none !important",
                borderBottom: "2px solid #1C485F",
                borderRadius: 0,
                color: "#1C485F",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Typography
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 700,
                  fontFamily: "Source Sans 3",
                }}
                component="h2"
              >
                All lists
              </Typography>
            </Button>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  backgroundColor: "#FAFAFA",
                  padding: "8px 12px",
                  borderRadius: "4px",
                  border: "1px solid #1c485f",
                }}
              >
                <SearchSvgIcon />
                <input
                  value={catchSearchValue}
                  onChange={handleSearchRecords}
                  type="text"
                  style={{
                    outline: "none",
                    backgroundColor: "transparent",
                    padding: "0px 12px",
                  }}
                  placeholder="Search.."
                />
              </Box>
              <button
                className="bg-primary"
                style={{
                  fontFamily: "Source Sans 3",
                  color: "#fff",
                  fontSize: "13px",
                  fontStyle: "normal",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  outline: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
                onClick={() => {
                  history.push("/Contacts/Import-options");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2010_4013)">
                    <path
                      d="M8 16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5701 22H14.0001C11.7101 22 10.5701 20.86 10.5701 18.57V11.43C10.5701 9.14 11.7101 8 14.0001 8H18.5701C20.8601 8 22.0001 9.14 22.0001 11.43V18.57C22.0001 20.86 20.8601 22 18.5701 22Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.8701 15H18.1301"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.5 16.63V13.37"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2010_4013">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Create a List
              </button>
            </div>
          </Box>
          {/* <GoalContacts /> */}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              {showLoader ? (
                // this body for display loading
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : visibleRows.length > 0 ? (
                <>
                  {/* table header */}
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                    >
                      {headCells.map((headCell, index) => (
                        <TableCell
                          key={headCell.id}
                          align={
                            index === 3
                              ? "center"
                              : index === 2
                              ? "center"
                              : "left"
                          }
                        >
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            fontSize={"13px"}
                          >
                            {headCell.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* // this body is for displaying data */}
                  <TableBody>
                    {rows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#FFF" : "#FAFAFA",
                          }}
                        >
                          <TableCell align="left">
                            <p
                              style={{
                                marginTop: "0px",
                                fontFamily: "Source Sans 3",
                                fontSize: "15px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                color: "#1C485F",
                              }}
                            >
                              {row.Name}
                            </p>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <span
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {row.ContactCount}
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <span
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {convertDatetoExactFormat(row.createdAt)}
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                              }}
                            >
                              <button
                                style={{
                                  fontSize: "12px",
                                  color: "#1c485f",
                                  fontWeight: 400,
                                  fontFamily: "Source Sans 3",
                                  fontStyle: "normal",
                                  outline: "none",
                                  padding: "8px 10px",
                                  border: "1px solid #868686",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  backgroundColor: "#D1DFE9",
                                }}
                                onClick={() => {
                                
                                  setOpenCreateContactForm(true);
                                  setSelectedListId(row);
                                  setFormFields({
                                    Contacts: row.Contact[0],
                                    listId: row._id,
                                  });
                                  const allowedKeys = [
                                    "FirstName",
                                    "LastName",
                                    "Email",
                                    "Phone",
                                    "CompanyName",
                                    "Website",
                                    "Do not import",
                                  ];
                                  let results = row.SampleContact;
                                  console.log("add",results)
                                  let filteredKeyValuePairs = Object.entries(
                                    results
                                  )
                                    .filter(
                                      ([key, value]) =>
                                        typeof value === "string" &&
                                        allowedKeys.includes(key) &&
                                        value.trim() !== ""
                                    )
                                    .map(([key, value]) => ({
                                      label: key,
                                      value: value,
                                      name: key,
                                      type:
                                        key === "Email"
                                          ? "email"
                                          : key === "Phone"
                                          ? "number"
                                          : "text",
                                    }))
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    );
                                   
                                  setFormFieldArray(filteredKeyValuePairs);
                                  let dynamicFieldsOfArray = Object.entries(
                                    results
                                  )
                                    .filter(
                                      ([key, value]) =>
                                        typeof value === "string" &&
                                        allowedKeys.includes(key) &&
                                        value.trim() !== ""
                                    )
                                    .map(([key, value]) => ({
                                      label: key,
                                      value: "",
                                      name: key,
                                      type:
                                        key === "Email"
                                          ? "email"
                                          : key === "Phone"
                                          ? "number"
                                          : "text",
                                    }))
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    );
                                  setDuplicateFormArray(dynamicFieldsOfArray);
                                  let vig = [];
                                  dynamicFieldsOfArray.map((val) => {
                                    if (val.name === "FirstName") {
                                      vig.push("First Name");
                                    }
                                    if (val.name === "LastName") {
                                      vig.push("Last Name");
                                    }
                                    if (val.name === "Email") {
                                      vig.push("Email");
                                    }
                                    if (val.name === "Phone") {
                                      vig.push("Phone Number");
                                    }
                                    if (val.name === "CompanyName") {
                                      vig.push("Company Name");
                                    }
                                    if (val.name === "Website") {
                                      vig.push("Website");
                                    }
                                  });
                                  vig.push("Do Not Import");
                                  setTypesArr(vig);
                                  console.log(
                                    "formfiled duplicate",
                                    dynamicFieldsOfArray
                                  );
                                }}
                              >
                                <Tooltip title="Add contacts to this list" arrow 
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                >
                                  <path
                                    d="M5.40039 10H15.4004"
                                    stroke="#1c485f"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.4004 15V5"
                                    stroke="#1c485f"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Add
                                </Tooltip>
                              </button>
                              <button
                                style={{
                                  fontSize: "12px",
                                  color: "#868686",
                                  fontWeight: 400,
                                  fontFamily: "Source Sans 3",
                                  fontStyle: "normal",
                                  outline: "none",
                                  padding: "8px 10px",
                                  border: "1px solid #868686",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                                onClick={() => {
                                  setSelectedListId(row);
                                  setValue(null);
                                  history.push(`/Contacts/${row._id}`);
                                  console.log("list contacts", {
                                    Contacts: row.Contact,
                                    ListName: row.Name,
                                  });
                                  setSelectedListContacts({
                                    Contacts: row.Contact,
                                    ListName: row.Name,
                                  });
                                  setSelectedListContactsCopy({
                                    Contacts: row.Contact,
                                    ListName: row.Name,
                                  });
                                }}
                              >
                                <Tooltip title="View the list" arrow style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}>
                                  
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                >
                                  <path
                                    d="M13.3846 9.99896C13.3846 11.649 12.0513 12.9823 10.4013 12.9823C8.7513 12.9823 7.41797 11.649 7.41797 9.99896C7.41797 8.34896 8.7513 7.01562 10.4013 7.01562C12.0513 7.01562 13.3846 8.34896 13.3846 9.99896Z"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.4003 16.8932C13.3419 16.8932 16.0836 15.1599 17.9919 12.1599C18.7419 10.9849 18.7419 9.0099 17.9919 7.8349C16.0836 4.8349 13.3419 3.10156 10.4003 3.10156C7.45859 3.10156 4.71693 4.8349 2.80859 7.8349C2.05859 9.0099 2.05859 10.9849 2.80859 12.1599C4.71693 15.1599 7.45859 16.8932 10.4003 16.8932Z"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                View
                                    </Tooltip>
                              </button>
                              {/* {moreActions(row._id)} */}
                              <button
                                onClick={() => setOpen3(true)}
                                style={{
                                  outline: "none",
                                  fontSize: "12px",
                                  padding: "8px 10px",
                                  border: "1px solid #868686",
                                  borderRadius: "4px",
                                }}
                              >
                                <Tooltip title="Edit a list" arrow>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M9.16602 1.66699H7.49935C3.33268 1.66699 1.66602 3.33366 1.66602 7.50033V12.5003C1.66602 16.667 3.33268 18.3337 7.49935 18.3337H12.4993C16.666 18.3337 18.3327 16.667 18.3327 12.5003V10.8337"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M13.3675 2.51639L6.80088 9.08306C6.55088 9.33306 6.30088 9.82472 6.25088 10.1831L5.89254 12.6914C5.75921 13.5997 6.40088 14.2331 7.30921 14.1081L9.81754 13.7497C10.1675 13.6997 10.6592 13.4497 10.9175 13.1997L17.4842 6.63306C18.6175 5.49972 19.1509 4.18306 17.4842 2.51639C15.8175 0.849722 14.5009 1.38306 13.3675 2.51639Z"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M12.4258 3.45801C12.9841 5.44967 14.5424 7.00801 16.5424 7.57467"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                </Tooltip>
                              </button>
                              <button
                                style={{
                                  outline: "none",
                                  fontSize: "12px",
                                  outline: "none",
                                  padding: "8px 10px",
                                  border: "1px solid #868686",
                                  borderRadius: "4px",
                                }}
                                onClick={() => {
                                  setOpen2(true);
                                  setSelectedListId(row);
                                }}
                              >
                                <Tooltip title="Delete a list" arrow>
                                    
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.08398 4.14199L7.26732 3.05033C7.40065 2.25866 7.50065 1.66699 8.90898 1.66699H11.0923C12.5007 1.66699 12.609 2.29199 12.734 3.05866L12.9173 4.14199"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M15.7077 7.61621L15.166 16.0079C15.0743 17.3162 14.9993 18.3329 12.6743 18.3329H7.32435C4.99935 18.3329 4.92435 17.3162 4.83268 16.0079L4.29102 7.61621"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8.60742 13.75H11.3824"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.91602 10.417H12.0827"
                                    stroke="#868686"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                </Tooltip>
                              </button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                // this body for displaying empty data
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          gap: "8px",
                          padding: "12px",
                        }}
                      >
                        <img
                          src={noListData}
                          alt="no-data"
                          style={{ height: "220px" }}
                        />
                        <p
                          style={{
                            color: "#393939",
                            fontSize: "22px",
                            fontWeight: 700,
                            fontFamily: "Source Sans 3",
                            fontStyle: "normal",
                          }}
                        >
                          No data found
                        </p>
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#868686",
                            fontStyle: "normal",
                            marginTop: "0px",
                          }}
                        >
                          {catchSearchValue.length !== 0
                            ? `There's no list that fits your search`
                            : `Oops! You don’t have any list yet Please create list.`}
                        </p>
                        <button
                          style={{
                            backgroundColor: "#FF3301",
                            color: "#FFF",
                            ontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontWeight: 400,
                            padding: "8px 22px",
                            borderRadius: "4px",
                            outline: "none",
                          }}
                          onClick={handleOpenModal}
                        >
                          Create a list
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={headCells.length} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {showLoader
            ? null
            : rows.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
    );
  };
  const handleContactFormSubmit = (values, actions) => {
    let nameListData = {
      contact: [
        {
          Name: `${values.firstName} ${values.lastName}`,
          Email: values.email,
          Phone: `${values.phoneNumber}`,
          FirstName: values.firstName,
          LastName: values.lastName,
          CompanyName: "",
          Website: "",
          Subscriber: false,
          Blocked: false,
          SendingOption: "Unverified",
        },
      ],
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }/${values.listName}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        // console.log("rres", response);
        if (response.data.status) {
          setOpenCreateContactForm(false);
          setStaus(true);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          // getAllContactDetails()
          getAllNameList();
        } else {
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));

    actions.resetForm();
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    dirty,
    isValid,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      listName: "",
    },
    validationSchema: createContactFormSchema,
    onSubmit: handleContactFormSubmit,
  });

  const handleAddContactFormSubmit = (received, actions) => {
    // console.log('received',received.friends)
    // console.log('actions',actions)
    let nameListData = {
      contact: [
        {
          Name: `${
            received.friends.FirstName !== "" ? received.friends.FirstName : ""
          } ${
            received.friends.LastName !== "" ? received.friends.LastName : ""
          }`,
          Email: received.friends.Email !== "" ? received.friends.Email : "",
          Phone: received.friends.Phone !== "" ? received.friends.Phone : "",
          FirstName:
            received.friends.FirstName !== "" ? received.friends.FirstName : "",
          LastName:
            received.friends.LastName !== "" ? received.friends.LastName : "",
          CompanyName:
            received.friends.CompanyName !== ""
              ? received.friends.CompanyName
              : "",
          Website:
            received.friends.Website !== "" ? received.friends.Website : "",
          Subscriber: false,
          Blocked: false,
          SendingOption: "Unverified",
        },
      ],
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }/${selectedListId._id}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpenCreateContactForm(false);
          setStaus(true);
          getAllNameList();
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          actions.resetForm();
        } else {
          setOpenCreateContactForm(false);
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };

  const generateValidationSchema = (formArray) => {
    const schemaObject = formArray.reduce((acc, field) => {
      switch (field.label) {
        case "Email":
          acc[field.name] = Yup.string()
            .email(`Invalid ${field.label}`)
            .required(`**${field.label} is required`)
            .test(
              "has-dot",
              `Invalid ${field.label}, must contain a dot.`,
              (value) => value && value.includes(".")
            );
          break;
        case "Phone":
          acc[field.name] = Yup.string()
            .matches(/^\d{10}$/, `Invalid ${field.label}, must be 10 digits`)
            .required(`**${field.label} is required`);
          break;
        default:
          acc[field.name] = Yup.string().required(
            `**${field.label} is required`
          );
      }
      return acc;
    }, {});

    return Yup.object().shape({
      friends: Yup.object().shape(schemaObject),
    });
  };
  const handleCloseDrawer = (received) => {
    setOpenDrawerForCreateList(received);
    setOpenCreateContactForm(false);
    getAllNameList();
  };
  const handleCreateListInDrawerComponent = () => {
    return (
      <Drawer
        placement={"right"}
        open={openDrawerForCreateList}
        onClose={() => {
          setOpenDrawerForCreateList(false);
          setOpenCreateContactForm(true);
        }}
        size="md"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            style={{
              padding: "10px 16px",
              borderBottom: "1px solid #DDD",
              flexShrink: 0,
            }}
          >
            <p
              style={{
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                color: "#393939",
                fontSize: "18px",
                fontWeight: 700,
                fontStyle: "normal",
                marginTop: "5px",
              }}
            >
              Create a new list
            </p>
          </div>
          <div
            style={{
              flexGrow: 1,
              overflowY: "scroll",
              backgroundColor: "#FFF",
              padding: "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <ImportForList
              selectedListId={selectedListId}
              typesArr={typesArr}
              closingFun={handleCloseDrawer}
            />
          </div>
          {/* <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-start",
              borderTop: "1px solid #DDD",
              flexShrink: 0,
              padding: "10px 16px",
            }}
          >
            <div
              onClick={() => {
                setOpenDrawerForCreateList(false);
                setOpenCreateContactForm(true);
              }}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#1C485F",
                backgroundColor: "#D1DFE9",
                border: "1px solid #1C485F",
                borderRadius: "6px",
                padding: "6px 24px",
                cursor: "pointer",
              }}
            >
              Cancel
            </div>
          </div> */}
        </div>
      </Drawer>
    );
  };
  const createContactFrom2 = () => {
    return (
      <>
        {formFieldArray.length !== 0 && (
          <div>
            <Drawer
              size="xs"
              open={true}
              onClose={() => setOpenCreateContactForm(false)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    padding: "16px",
                    borderBottom: "1px solid #DDD",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h1
                    style={{
                      lineHeight: "20px",
                      fontFamily: "Source Sans 3",
                      color: "#393939",
                      fontSize: "18px",
                      fontWeight: 700,
                      fontStyle: "normal",
                      marginTop: "5px",
                    }}
                  >
                    Add contact ({selectedListId.Name})
                  </h1>
                </div>

                <div
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Formik
                    initialValues={{
                      friends: duplicateFormArray.reduce((acc, current) => {
                        acc[current.name] = current.value;
                        return acc;
                      }, {}),
                    }}
                    onSubmit={(values, actions) => {
                      handleAddContactFormSubmit(values, actions);
                    }}
                    validationSchema={generateValidationSchema(
                      duplicateFormArray
                    )}
                    render={({ values }) => (
                      <Form
                        style={{
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <FieldArray
                          name="friends"
                          render={(arrayHelpers) => (
                            <div
                              style={{
                                flexGrow: 1,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div style={{ flexGrow: 1, overflowY: "scroll" }}>
                                {duplicateFormArray.map((field, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                      padding: "4px 12px",
                                    }}
                                  >
                                    <label
                                      htmlFor={field.name}
                                      style={{
                                        display: "flex",
                                        gap: "4px",
                                        alignItems: "center",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {field.label === "CompanyName"
                                        ? "Company Name"
                                        : field.label === "FirstName"
                                        ? "First Name"
                                        : field.label === "LastName"
                                        ? "Last Name"
                                        : field.label}
                                      <ErrorMessage
                                        name={`friends.${field.name}`}
                                        component="p"
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      />
                                    </label>
                                    <Field
                                      autoComplete="off"
                                      type={field.type}
                                      name={`friends.${field.name}`}
                                      value={values.friends[field.name]}
                                      placeholder={`Enter ${
                                        field.label === "CompanyName"
                                          ? "Company Name"
                                          : field.label === "FirstName"
                                          ? "First Name"
                                          : field.label === "LastName"
                                          ? "Last Name"
                                          : field.label
                                      }`}
                                      style={{
                                        backgroundColor: "#FAFAFA",
                                        borderRadius: "4px",
                                        padding: "7px",
                                        border: "1px solid #1C485F",
                                        outline: "none",
                                      }}
                                    />
                                  </div>
                                ))}
                                <div
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                    paddingTop: "10px",
                                  }}
                                >
                                  OR
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      setOpenDrawerForCreateList(true);
                                      setOpenCreateContactForm(false);
                                    }}
                                    style={{
                                      fontFamily: "Source Sans 3",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: 400,
                                      color: "#1C485F",
                                      backgroundColor: "#D1DFE9",
                                      border: "1px solid #1C485F",
                                      borderRadius: "6px",
                                      padding: "6px 24px",
                                      cursor: "pointer",
                                      margin: "12px",
                                      width: "max-content",
                                    }}
                                  >
                                    Bulk Import
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  borderTop: "1px solid #DDD",
                                  gap: "12px",
                                  padding: "10px 12px",
                                  justifyContent: "flex-start",
                                  flexShrink: 0,
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    setOpenCreateContactForm(false)
                                  }
                                  style={{
                                    backgroundColor: "red",
                                    padding: "6px 12px",
                                    borderRadius: "4px",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    border: "1px solid #1C485F",
                                    color: "#1C485F",
                                    backgroundColor: "transparent",
                                    borderRadius: "4px",
                                    padding: "7px 12px",
                                    outline: "none",
                                  }}
                                >
                                  Not Now
                                </button>
                                <button
                                  type="submit"
                                  style={{
                                    background: "#ff3301",
                                    outline: "none",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        />
                      </Form>
                    )}
                  />
                </div>
              </div>
            </Drawer>
          </div>
        )}
      </>
    );
  };
  function renameNameList() {
    let listId = {
      name: listName,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/update-name-in-name-list/${
          userDetails && userDetails.details._id
        }/${nameListId}`,
        listId,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpen3(false);
          getAllNameList();
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  const EnhancedTableToolbarCopy = (props) => {
    const { numSelected } = props;
    return (
      <Box
        style={{
          display: "flex",
          justifyContent:
            location.pathname === "/Contacts" ? "space-between" : "flex-end",
          alignItems: "center",
          padding: "0px 16px 8px 16px",
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        <p
          style={{
            fontSize: "26px",
            color: "#4B4B4B",
            fontWeight: 700,
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
          }}
        >
          {/* {selectedListContacts.ListName && location.pathname === "/Contacts" && selectedListContacts.ListName} */}
        </p>
        <Box className="flex items-center gap-3">
          {location.pathname === "/Lists" && (
            <button
              className="bg-primary"
              style={{
                fontFamily: "Source Sans 3",
                color: "#fff",
                fontSize: "13px",
                fontStyle: "normal",
                padding: "10px 20px",
                borderRadius: "4px",
                outline: "none",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
              onClick={() => {
                history.push("/Contacts/Import-options");
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_2010_4013)">
                  <path
                    d="M8 16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.5701 22H14.0001C11.7101 22 10.5701 20.86 10.5701 18.57V11.43C10.5701 9.14 11.7101 8 14.0001 8H18.5701C20.8601 8 22.0001 9.14 22.0001 11.43V18.57C22.0001 20.86 20.8601 22 18.5701 22Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8701 15H18.1301"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.5 16.63V13.37"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2010_4013">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Create a List
            </button>
          )}
        </Box>
      </Box>
    );
  };

  const catchListTile = (catchTitle) => {
    setSelectedList(catchTitle);
  };
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        borderRadius: "5px",
        backgroundColor: "transparent",
      }}
    >
      <Helmet>
        <title>Lists</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      {openCreateContactForm && createContactFrom2()}
      {showToaster && <ToastContainer />}
      {listComponentUi()}
      {openDrawerForCreateList && handleCreateListInDrawerComponent()}
      <Modal
        open={open2}
        onClose={() => {
          setOpen2(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Confirm Delete</div>
          <div className="modalsubtext">
          Are you certain you wish to proceed with deleting this List? Please note that it will take some time to complete the deletion process after clicking the delete button
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen2(false);
              }}
            >
              Cancel
            </div>
            <div
             className="continuebuttonmodal"
             onClick={() => {
               deleteListName();
             }}
           > 
           {deleteLoader?<div style={{paddingLeft:'18px',paddingRight:'18px'}}><CircularProgress size={18} sx={{ color: "white" }}/></div>:"Continue"}
             
           </div>
           
          </div>
        </div>
      </Modal>
      <Modal
        open={open3}
        onClose={() => {
          setOpen3(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopup" style={{ width: window.innerWidth / 1.9 }}>
          <div className="modaltext">Rename List</div>
          <div className="modalsubtext">What would you like to name it?</div>

          <div className="modalmoxtextlabel">List Name</div>
          <TextField
            autoComplete="off"
            value={listName}
            onChange={(e) => {
              setListName(e.target.value);
            }}
            variant="standard"
            placeholder="Ex:My Campaign"
            InputProps={{
              disableUnderline: true,

              sx: {
                display: "flex",
                padding: "10px 16px",
                alignItems: "center",
                gap: "10px",
                borderRadius: "4px",
                border: "1px solid #1C485F",
                background: "var(--background-color, #FAFAFA)",
                width: window.innerWidth / 2.04,

                "& input": {
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                },
              },
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "32px",
              width: window.innerWidth / 2.04,
            }}
          >
            <div style={{ alignItems: "center", display: "flex", gap: "10px" }}>
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen3(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  renameNameList();
                }}
              >
                Rename
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
